export default __webpack_public_path__ + "static/media/Calaverandia_Logo.e039fa2d.png";